<template>
    <div class="col page-element">
        <alert-loading v-if="loading"></alert-loading>
        <page-title v-if="!loading"><h3>Lista faktur</h3></page-title>
        <div v-if="!loading" class="table-responsive">
            <table class="table table-striped table-bordered table-hover table-clickable table-search">
                <thead>
                <tr>
                    <th>Umowa</th>
                    <th>Numer</th>
                    <th>Data wystawienia</th>
                    <th>Termin płatności</th>
                    <th>Kwota</th>
                    <th>Do zapłaty</th>
                    <th>Status</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items">
                    <td class="td-no_link">
                        {{ item.agreement.fullNumber }}
                    </td>
                    <td class="td-no_link">
                        {{ item['number'] }}
                    </td>
                    <td class="td-no_link">
                        {{ item['createDate'] | date }}
                    </td>
                    <td class="td-no_link">
                        {{ item['paymentDate'] | date }}
                    </td>
                    <td class="td-no_link">
                        {{ item['amount'] }}
                    </td>
                    <td class="td-no_link">
                        {{ item['leftToPaid'] }}
                    </td>
                    <td class="td-no_link">
                        <span v-if="item['paid']" class="element_status closed">Zapłacona</span>
                        <span v-if="!item['paid'] && !item['deducted']" class="element_status open">Niezapłacona</span>
                        <span v-if="item['deducted']" class="element_status deducted">Potrącona</span>
                        <span v-if="item['returned']" class="element_status returned">Zwrócona</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    data: function () {
      return {
        selectedInvoice: null,
        paymentData: {}
      }
    },
    computed: {
      ...mapGetters({
        error: 'debtor/factoredInvoice/error',
        loading: 'debtor/factoredInvoice/loading',
        items: 'debtor/factoredInvoice/items',
      })
    },
    props: {
      id: {
        type: String,
        default: '',
        required: true
      }
    },
    methods: {
      getInvoiceList () {
        this.$store.dispatch('debtor/factoredInvoice/getItems', this.id)
      }
    },
    created () {
      this.getInvoiceList()
    }
  }
</script>




// WEBPACK FOOTER //
// InvoiceList.vue?9db5024c